import '../../styles/EduComponents/SponsoredTrain.css';

import logo1 from '../../assets/Images/logo1.png';
import logo2 from '../../assets/Images/logo2.png';
import logo3 from '../../assets/Images/logo3.png';
import logo4 from '../../assets/Images/logo4.png';
import logo5 from '../../assets/Images/logo5.png';

const logos = [logo1, logo2, logo3, logo4, logo5];

const SponsoredTrain = () => {
  return (
    <section className="sponsored-section">
      <h2 className="sponsored-title">Trusted <span className="highlight">By</span></h2>

      <div className="marquee">
        <div className="marquee-track">
          {[...logos, ...logos].map((logo, i) => (
            <div className="marquee-item" key={i}>
              <img src={logo} alt="Sponsor logo" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SponsoredTrain;
